var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetweet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 4L0 8.286h2.5v5.143C2.5 14.846 3.622 16 5 16h9.666l-1.333-1.714H5a.846.846 0 01-.833-.857V8.286h2.5L3.333 4zm2 0l1.334 1.714H15c.46 0 .833.384.833.857v5.143h-2.5L16.667 16 20 11.714h-2.5V6.571C17.5 5.154 16.378 4 15 4H5.334z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetweet);
export default __webpack_public_path__ + "static/media/retweet.8c5c68792b45e894ed776a0a95f13da8.svg";
export { ForwardRef as ReactComponent };